import * as React from "react";

import { ObjectFieldRenderer } from "../Interfaces/objectFieldRenderer";

export const objectFieldRenderer: ObjectFieldRenderer = (props) => {
  const fullWidthClass = props.field.ui && props.field.ui.formGroupfullWidth ? "fieldset-full-width" : "";

  const beforeFieldContent: JSX.Element | null = props.field.beforeFieldContent ? (
    <>{props.field.beforeFieldContent}</>
  ) : null;

  const afterFieldContent: JSX.Element | null = props.field.afterFieldContent ? (
    <>{props.field.afterFieldContent}</>
  ) : null;

  return (
    <fieldset className={`object-field ${fullWidthClass} ${props.field.className ?? ""}`}>
      {beforeFieldContent && beforeFieldContent}
      {props.children}
      {afterFieldContent && afterFieldContent}
    </fieldset>
  );
};
